<template>
  <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
    <!-- Pending -->

    <div
      class="flex flex-col gap-2 bg-white shadow-[0_2px_8px_rgba(0,0,0,0.15)] rounded-lg py-14 text-center"
    >
      <p class="text-secondary text-base">Assessment</p>

      <p class="text-4xl font-bold text-primary">
        <router-link
          :to="{
            path: '/admin/reimbursement',
            query: {
              status: 'Assessment',
            },
          }"
        >
          {{ approvalTypeCountList.Assessment }}
        </router-link>
      </p>
    </div>
    <div
      class="flex flex-col gap-2 bg-white shadow-[0_2px_8px_rgba(0,0,0,0.15)] rounded-lg py-14 text-center"
    >
      <p class="text-secondary text-base">Pending Documents</p>
      <p class="text-4xl font-bold text-primary">
        <router-link
          :to="{
            path: '/admin/reimbursement',
            query: {
              status: 'Pending Documents',
            },
          }"
        >
          {{ approvalTypeCountList["Pending Documents"] }}
        </router-link>
      </p>
    </div>
    <div
      class="flex flex-col gap-2 bg-white shadow-[0_2px_8px_rgba(0,0,0,0.15)] rounded-lg py-14 text-center"
    >
      <p class="text-secondary text-base">Approved</p>
      <p class="text-4xl font-bold text-primary">
        <router-link
          :to="{
            path: '/admin/reimbursement',
            query: {
              status: 'Approved',
            },
          }"
        >
          {{ approvalTypeCountList.Approved }}
        </router-link>
      </p>
    </div>
    <div
      class="flex flex-col gap-2 bg-white shadow-[0_2px_8px_rgba(0,0,0,0.15)] rounded-lg py-14 text-center"
    >
      <p class="text-secondary text-base">Declined</p>
      <p class="text-4xl font-bold text-primary">
        <router-link
          :to="{
            path: '/admin/reimbursement',
            query: {
              status: 'Declined',
            },
          }"
        >
          {{ approvalTypeCountList.Declined }}
        </router-link>
      </p>
    </div>
  </div>
</template>
<script>
import { inject, onMounted, ref } from "vue";
export default {
  setup() {
    const axios = inject("$axios");
    const approvalTypeCountList = ref({});

    onMounted(() => {
      fetchGroupApprovalDataCount();
    });
    const fetchGroupApprovalDataCount = async () => {
      try {
        const { data } = await axios.get(
          `portal/application/reimbursement/approvaltype/count`
        );
        approvalTypeCountList.value = data;
      } catch (error) {
        console.error("Error fetching transactions:", error);
      }
    };
    return {
      fetchGroupApprovalDataCount,
      approvalTypeCountList,
    };
  },
};
</script>
